import { useEffect, useState } from 'react'
import {
  BillingType,
  HourlyAmountLoggedForCasePayload,
  useGetHourlyAmountLoggedForCaseLazyQuery
} from '../../generated'
import { GRAPHQL_QUERY_POLICY } from '../constants'
import { UseFetchHybridCaseFlatFeeConsumedResult } from '../interfaceTypes'

interface UseFetchHybridCaseFlatFeeConsumedProps {
  caseId: string
  billingType: BillingType | null
  isFlatFeeHoursExhausted: boolean | null
}

const useFetchHybridCaseFlatFeeConsumed = ({
  caseId,
  billingType,
  isFlatFeeHoursExhausted
}: UseFetchHybridCaseFlatFeeConsumedProps): UseFetchHybridCaseFlatFeeConsumedResult => {
  const [flatFeeConsumed, setFlatFeeConsumed] = useState<HourlyAmountLoggedForCasePayload['hourlyAmountLogged']>(0)

  const [getHourlyAmountLoggedForCase, { loading, refetch }] = useGetHourlyAmountLoggedForCaseLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onCompleted(data) {
      if (data) {
        const { getHourlyAmountLoggedForCase } = data
        const { hourlyAmountLogged, response } = getHourlyAmountLoggedForCase || {}
        const { status } = response || {}

        if (status === 200) {
          setFlatFeeConsumed(hourlyAmountLogged)
        }
      }
    }
  })

  useEffect(() => {
    if (billingType === BillingType.Hybrid && !isFlatFeeHoursExhausted) {
      getHourlyAmountLoggedForCase({
        variables: {
          caseId
        }
      })
    }

    return () => {
      setFlatFeeConsumed(0)
    }
  }, [caseId, getHourlyAmountLoggedForCase, refetch, billingType, isFlatFeeHoursExhausted])

  return {
    flatFeeConsumed,
    loading,
    refetch
  }
}

export default useFetchHybridCaseFlatFeeConsumed
